












































	import { Component, Vue } from "vue-property-decorator";
	import { Dialog,Toast } from "vant";
	@Component({
		name: "AccountOpening",
		components:{
			[Dialog.Component.name]: Dialog.Component
		}
	})
	export default class AccountOpening extends Vue {
		showCancel:Boolean = false;
		isUser:Boolean = true
		userclick() {
			let that = this
			that.showCancel = true;
			that.isUser = true;
			// Dialog.confirm({
			// 	["message" as any]: that.$t("selectopening.dialogMessage"),
			// 	["confirmButtonText" as any]:that.$t("selectopening.yes"),
			// 	["cancelButtonText" as any]:that.$t("selectopening.no")
			// })
			// .then(() => {
			// 	(this as any).$router.push({
			// 	  name: "ModeSelect"
			// 	});
			// })
			// .catch(() => {
			// 	Toast(that.$t("selectopening.toastMessage"));
			// });

		}

		handConfirm(){
			let that = (this as any)
			that.showCancel = false;
      // 跳转到 推荐人页面  参数带到下一级页面去
      let name = "InstitutionalOpen";
      setTimeout(()=>{
        if(that.isUser){
          name = "ModeSelect"
        }
        (this as any).$router.push({
          path: "open-reference",
          query: {
            name
          }
        });
      }, 300);


		}
		handCancel(){
			let that = this
			that.showCancel = false;
			Toast(that.$t("selectopening.toastMessage"));
		}


		get bgColor() {
			return this.$store.getters["common/bgColor"];
		}

		get bgColorDialog(){
		  return this.bgColor !== 'white-theme' ? 'black-theme-dialog' : ''
		}

		InstitutionalOpen() {
			let that = this
			that.showCancel = true;
			that.isUser = false;
			// Dialog.confirm({
			// 	["message" as any]: that.$t("selectopening.dialogMessage"),
			// 	["confirmButtonText" as any]:that.$t("selectopening.yes"),
			// 	["cancelButtonText" as any]:that.$t("selectopening.no")
			// })
			// .then(() => {
			// 	(this as any).$router.push({
			// 		name: "InstitutionalOpen"
			// 	});
			// })
			// .catch(() => {
			// 	Toast(that.$t("selectopening.toastMessage"));
			// });

		}
	}
